import { useCallback } from 'react';

import useCreateConfirmationPageHook from 'components/SubPages/Confirmation/useCreateConfirmationPageHook';

import useP2PEnrollmentFlow from 'hooks/useP2PEnrollmentFlow';
import { useUserContext } from 'hooks/useUserContext';

import {
  trackCTATapped,
  trackReceiveFromAnyoneConfirmationInfoPageViewed,
} from 'utils/segment/trackingEvents';

type UseReceiveFromAnyoneConfirmationApi = {
  onJoinChimeClick: () => void;
  trackConfirmationAnimationViewed: () => void;
};

function useReceiveFromAnyoneConfirmationPage(): UseReceiveFromAnyoneConfirmationApi {
  const [userData] = useUserContext();
  const { publicId } = userData;
  const { activateP2pEnrollmentAndNavigate } = useP2PEnrollmentFlow(
    false //Claim with Chime is not enabled in Receive From Anyone yet
  );

  const trackPageViewed = () => {
    trackReceiveFromAnyoneConfirmationInfoPageViewed(publicId, 'join chime');
  };

  const trackAndNavigateToEnrollment = () => {
    const trackJoinChimeCTATapped = () =>
      trackCTATapped(
        `P2P Request Payment`,
        'Join Chime',
        'P2P Request Payment Confirmation Page',
        'p2p_request_payment_confirmation_join_chime_button',
        publicId
      );

    activateP2pEnrollmentAndNavigate(trackJoinChimeCTATapped);
  };

  const trackConfirmationAnimationViewed = useCallback(() => {
    trackReceiveFromAnyoneConfirmationInfoPageViewed(publicId, 'you paid');
  }, [publicId]);

  const { trackCtaButtonClick } = useCreateConfirmationPageHook(
    trackPageViewed,
    trackAndNavigateToEnrollment
  );

  return {
    onJoinChimeClick: trackCtaButtonClick,
    trackConfirmationAnimationViewed,
  };
}

export default useReceiveFromAnyoneConfirmationPage;
